import { AppFooter } from "./components/AppFooter";
import { AppHeader } from "./components/AppHeader";
import { DeskViewProvider } from "./desk/DeskViewProvider";
import { SessionGate } from "./screens/SessionGate";
import type { DeskDependencies } from "./screens/DeskScreen";
import { SessionProvider } from "./session/SessionProvider";
import type { SessionProviderProps } from "./session/SessionProvider";
import { ThemeProvider } from "./theme/ThemeProvider";

/**
 * The seller app shell.
 *
 * The session and desk dependencies are props with real defaults so the suite can drive
 * every session branch and every panel state without a network, while the shipped app
 * always uses the browser's own address bar and dealbid-core.
 */
export type AppProps = Omit<SessionProviderProps, "children"> & DeskDependencies;

export function App({
  loadDeals,
  loadCredit,
  loadAuction,
  loadPlacements,
  loadBids,
  placeBid,
  purchaseMention,
  loadDealDetail,
  saveDeal,
  loadTerms,
  submitDeal,
  ...session
}: AppProps) {
  return (
    <ThemeProvider>
      <SessionProvider {...session}>
        {/*
          * The desk's view state sits above the masthead and the desk both (`APP-017`): the
          * masthead's `Submit a deal` opens a form the desk renders, and the tab row moves a
          * view the desk shows. See `src/desk/DeskViewContext.ts`.
          */}
        <DeskViewProvider>
          <AppHeader />
          <SessionGate
            loadDeals={loadDeals}
            loadCredit={loadCredit}
            loadAuction={loadAuction}
            loadPlacements={loadPlacements}
            loadBids={loadBids}
            placeBid={placeBid}
            purchaseMention={purchaseMention}
            loadDealDetail={loadDealDetail}
            saveDeal={saveDeal}
            loadTerms={loadTerms}
            submitDeal={submitDeal}
          />
        </DeskViewProvider>
        <AppFooter />
      </SessionProvider>
    </ThemeProvider>
  );
}
